'helper'.trashAll('Template')
'helper'.trashAll('Facet')
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.trashAll('POLine')
'helper'.trashAll('PO')
'helper'.trashAll('Supplier')
'helper'.trashAll('Configuration')
'helper'.trashAll('Currency')
'helper'.clearWCStockLevels()
'helper'.flushCache()
'helper'.simulateBrowserRefresh()
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('ATUM Supplier 1')
    'Code'.enter('ATUM01')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('682526')
    'Supplier'.enter('ATUM Supplier 1')
    'OK'.click()
  'Back'.click()
'Import data from ATUM'.click()
  'Start'.click()
    'messageDialogText'.shouldEqual("Copy failed. Currency BTC not found - please configure via Profitori > Settings > Currencies", 'doc')
    'OK'.click()
  'Back'.click()
'stocktend_settings'.click()
  'Currencies'.click()
    'Add'.click()
      'Currency Code'.enter('BTC')
      'Exchange Rate'.enter('0.5')
      'OK'.click()
    'Back'.click()
  'Back'.click()
'Import data from ATUM'.click()
  'Start'.click()
    'messageDialogText'.shouldEqual("Copy complete. Suppliers added: 1 modified: 1; Products updated: 2; Purchase Orders added: 3 modified: 1", 'doc')
    'OK'.click('doc')
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable'.shouldHaveCount(4)
  'mainTable./682526/.Edit'.click()
    'Order Date'.shouldEqual('28/07/2020')
    'Supplier'.shouldEqual('ATUM Supplier 1')
    'Expected Delivery Date'.shouldEqual('30/07/2020')
    'Stage'.shouldEqual('Entered')
    'Notes for Supplier'.shouldEqual('Test Notes')
    'Lines./Hoodie (H01)/.Edit'.click()
      'Line Type'.shouldEqual('Product')
      'Description'.shouldEqual('Hoodie')
      'Quantity'.shouldEqual('2')
      'Unit Price (Inc Tax)'.shouldEqual('13.75')
      'Line Tax'.shouldEqual('2.50')
      'Line Total (Inc Tax)'.shouldEqual('27.50')
      'OK'.click()
    'Lines./Shipping/.Edit'.click()
      'Line Type'.shouldEqual('Shipping')
      'Description'.shouldEqual('Shipping')
      'Quantity'.shouldEqual('1')
      'Unit Price (Inc Tax)'.shouldEqual('132.00')
      'Line Tax'.shouldEqual('12.00')
      'Line Total (Inc Tax)'.shouldEqual('132.00')
      'OK'.click()
    'Lines./Fee 1/.Edit'.click()
      'Line Type'.shouldEqual('Fee')
      'Description'.shouldEqual('Fee 1')
      'Quantity'.shouldEqual('1')
      'Unit Price (Inc Tax)'.shouldEqual('14.30')
      'Line Tax'.shouldEqual('1.30')
      'Line Total (Inc Tax)'.shouldEqual('14.30')
      'OK'.click()
    'Order Total (Inc Tax)'.shouldEqual('173.80')
    'Status'.shouldEqual('Awaiting Delivery')
    'Stage'.shouldEqual('Entered')
    'Back'.click()
  'mainTable./722422/.Edit'.click()
    'Order Date'.shouldEqual('04/08/2020')
    'Supplier'.shouldEqual('ATUM Supplier 2')
    'Stage'.shouldEqual('Goods In Transit')
    'Status'.shouldEqual('Awaiting Delivery')
    'Back'.click()
  'mainTable./722421/.Edit'.click()
    'Stage'.shouldEqual('Sent to Supplier')
    'Status'.shouldEqual('Awaiting Delivery')
    'Back'.click()
  'mainTable./722423/.Edit'.click()
    'Stage'.shouldEqual('Goods Arrived')
    'Status'.shouldEqual('Awaiting Delivery')
    'Back'.click()
  'Back'.click()
'Inventory'.click()
  'mainTable./Hoodie (H01)/.Product'.click()
    'Last Purchase Unit Cost (Inc Tax)'.shouldEqual('27.50')
    'Avg Unit Cost'.shouldEqual('27.50')
    'Suppliers.0.Supplier'.shouldEqual('ATUM Supplier 1')
    'Suppliers.0.Supplier SKU'.shouldEqual('SH01')
    'Suppliers.0.Main'.shouldEqual('Yes')
    'Back'.click()
  'mainTable./Belt (#33)/.Product'.click()
    'Last Purchase Unit Cost (Inc Tax)'.shouldEqual('32.31')
    'Avg Unit Cost'.shouldEqual('32.31')
    'Suppliers.0.Supplier'.shouldEqual('ATUM Supplier 2')
    'Suppliers.0.Supplier SKU'.shouldEqual('SBELT')
    'Suppliers.0.Main'.shouldEqual('Yes')
    'Back'.click()
  'Back'.click()
'stocktend_suppliers'.click()
'mainTable'.shouldHaveCount(2)
'mainTable.0.Edit'.click()
'Name'.shouldEqual('ATUM Supplier 1')
'Code'.shouldEqual('ATUM01')
'Tax Number'.shouldEqual('Tax Number')
'Phone'.shouldEqual('0433318462')
'Fax'.shouldEqual('0555555555')
'Web Site'.shouldEqual('http://www.atum.org')
'Ordering URL'.shouldEqual('http://www.atum.org/ordering')
'Email'.shouldEqual('email@atum.org')
'Ordering Email'.shouldEqual('ordering@atum.org')
'Notes'.shouldEqual('Supplier Desc Line 1\nSupplier Desc Line 2')
'Currency'.shouldEqual('BTC')
'Address'.shouldEqual('201/4 Villa St')
'City/Suburb/Town'.shouldEqual('HEIDELBERG')
'State'.shouldEqual('VIC')
'Postal/Zip Code'.shouldEqual('3084')
'Country'.shouldEqual('AU')
'Discount %'.shouldEqual('10.00')
'Tax %'.shouldEqual('14.00')
'Delivery Lead Days'.shouldEqual('13')
'Back'.click()
'mainTable.1.Edit'.click()
'Name'.shouldEqual('ATUM Supplier 2')
'Code'.shouldEqual('ATUM02')
'Tax Number'.shouldEqual('12345')
'Phone'.shouldEqual('0433331898')
'Fax'.shouldEqual('0555555555')
'Web Site'.shouldEqual('http://www.atum2.org')
'Ordering URL'.shouldEqual('http://www.atum2.org/ordering')
'Email'.shouldEqual('email2@atum.org')
'Ordering Email'.shouldEqual('ordering@atum.org')
'Notes'.shouldEqual('Supplier 2 \nLine 2')
'Currency'.shouldEqual('')
'Address'.shouldEqual('604/770D Toorak Rd')
'City/Suburb/Town'.shouldEqual('Glen Iris')
'State'.shouldEqual('Victoria')
'Postal/Zip Code'.shouldEqual('3146')
'Country'.shouldEqual('BS')
'Discount %'.shouldEqual('14.00')
'Tax %'.shouldEqual('11.00')
'Delivery Lead Days'.shouldEqual('12')
'Back'.click()
'Back'.click()
'Home'.shouldBeCurrentPage()
'helper'.simulateBrowserRefresh()
'stocktend_purchaseOrders'.click()
'mainTable./682526/.Edit'.click()
'Order Total (Inc Tax)'.shouldEqual('173.80')
'Tax'.shouldEqual('15.80')
'OK'.click()
